import React from "react";
import { currencyConvert, getString, isAFunction } from "../../utilities";
import { getLangCode, language } from "../../config";

export default function SubscriptionCard({
  plan,
  setPlan = () => {},
  setPlanAmount,
  subscription,
  planData,
  isBest,
  showRenew,
  tabIndex = 0,
  role = "button",
  activeClick,
}) {
  let titleStringPath = "annual.0";
  const langCode = getLangCode();
  const isMonthly = subscription === "m1";
  const subStyleArray = ["sub-card", "subscribe-focus"];
  const isActive = plan === subscription;

  if (showRenew) {
    subStyleArray.push("renew");

    if (isMonthly) {
      titleStringPath = "monthly.0";
    } else if (langCode === language.default) {
      titleStringPath = "yearly.0";
    }
  }

  const titleString = getString(titleStringPath);

  const ariaCheckedProps = {
    ...(role === "radio" && { "aria-checked": isActive }),
    ...(role === "button" && { "aria-pressed": isActive }),
  };

  const ariaLabelProps = {
    ...(isActive && { "aria-label": getString("subscribe.plans.proceed", { replace: [titleString?.toLowerCase()] }) }),
  };

  if (!planData) {
    subStyleArray.push("disabled");
  }
  if (isActive) {
    subStyleArray.push("active");
  }

  const setSubscription = () => {
    if (!planData) return;

    if (isActive && isAFunction(activeClick)) {
      activeClick();
    } else {
      if (isAFunction(setPlanAmount)) {
        setPlanAmount(planData?.[subscription].amount);
      }
      setPlan(subscription);
    }
  };

  const renderBest = () => {
    if (isBest) {
      return (
        <div className={`sub-card-best ${langCode}`}>
          <span>{getString(`subscribe.plans.best`)}</span>
        </div>
      );
    }

    return null;
  };

  const renderCost = () => {
    const costData = showRenew ? planData?.[subscription]?.monthly : planData?.[subscription]?.total;

    return (
      <>
        <div className="currency-symbol">{getString("currencySymbol.usd")}</div>
        <div className="dollars">{costData?.dollars}</div>
        <div className="cents-term">
          <div className="cents">{costData?.cents}</div>
          <div className="term">
            {getString(showRenew || isMonthly ? "subscribe.plans.terms.month" : "subscribe.plans.terms.year")}
          </div>
        </div>
      </>
    );
  };

  return (
    <button
      type="button"
      data-testid={`subscription-card-${subscription}`}
      className={subStyleArray.join(" ")}
      onClick={setSubscription}
      tabIndex={tabIndex}
      role={role}
      {...ariaLabelProps}
      {...ariaCheckedProps}
    >
      {renderBest()}

      <div className="sub-card-title">{titleString}</div>

      <div className="sub-card-cost">{renderCost()}</div>

      {!!planData?.[subscription] && showRenew && (
        <div className="sub-card-renewal">
          {getString(`subscribe.plans.renew.${isMonthly ? "month" : "year"}`, {
            html: true,
            replace: [currencyConvert(planData[subscription].amount)],
          })}
        </div>
      )}
    </button>
  );
}
